import { render } from "./batch-insure.vue?vue&type=template&id=284ca980&scoped=true&ts=true"
import script from "./batch-insure.vue?vue&type=script&lang=ts"
export * from "./batch-insure.vue?vue&type=script&lang=ts"

import "./batch-insure.vue?vue&type=style&index=0&id=284ca980&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284ca980"]])

export default __exports__